export const getToken = () => sessionStorage.getItem('token');